module.exports = __webpack_public_path__ + "static/media/5.a802e0d9.jpg";